import apiUrl from "../utils/apiUrl";
import fetch from "../utils/mgFetch";

const postLanguage = (token, IsoLanguage, Description) => {
    return fetch(`${apiUrl}languages`, {
        method: "POST",
        headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            IsoLanguage,
            Description
        })
    });
}

export default postLanguage